import {API, NEW_API} from "../HttpHandler";
import config from "../../../config";

export const getFirebaseToken = () => {
  return NEW_API.post(config.endPoints.firebasetoken, {});
};
